// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { UserProvider } from './contexts/UserContext';
import './i18n';
import './index.css';
import "react-toastify/dist/ReactToastify.css";

// Global axios interceptor to add view_mode parameter when admin views as user
axios.interceptors.request.use(
  (config) => {
    const viewMode = localStorage.getItem('viewMode');
    if (viewMode === 'user') {
      // Add view_mode to query params for all requests
      config.params = config.params || {};
      config.params.view_mode = 'user';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <UserProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </UserProvider>
  </React.StrictMode>
);
